import { render } from "./PopUpStudentEdit.vue?vue&type=template&id=01e7465c"
import script from "./PopUpStudentEdit.vue?vue&type=script&lang=js"
export * from "./PopUpStudentEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__